import React from 'react';

import './summary-blank.scss';

const CompanyViewCardSummaryBlank: React.FC = () => (
    <div className="company-view-card__summary company-view-card__summary-blank">
        <p className="company-view-card__summary-blank-header">
            Sprzedawca nie korzysta z usług opineo.pl
            {''}
            <br />
            {''}
            Programu Słucham Swoich Klientów
        </p>
        <p>
            uczestnik Programu SSK może skomentować opinię
            {''}
            <br />
            {''}
            lub prowadzić z kupującym rozmowę w OpiConnect
        </p>
    </div>
);

export default CompanyViewCardSummaryBlank;
